<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-info">
          <form @submit.prevent class="form-horizontal">
            <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
            <div class="box-body">
              <div class="box no-border">
                <div class="col-md-8">                    
                  <div class="form-group">
                    <label for="inputName">Name</label>
                    <h1 style="margin-top:0px;">
                      <input type="text" :disabled="viewMode != MODE_CREATE" class="form-control" id="inputName" placeholder="Role Name" v-model="formData.name">
                    </h1>                        
                  </div>                                                                                      
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_MENU }"><a @click="onClickTabMenu(formData.id)" href="#tab_1" data-toggle="tab" aria-expanded="false">Menu/Transaction</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_AUTHOBJECT }"><a @click="onClickTabAuthObject(formData.id)" href="#tab_2" data-toggle="tab" aria-expanded="true">Authorization Objects</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_MENU }" class="tab-pane" id="tab_1">
                      <div class="col-md-12">
                        <div class="box no-border">
                          <div class="box-header" style="height:40px;">          
                            <div class="box-tools">              
                              <button @click="onCreateRoleMenu" class="btn btn-primary" v-if="viewMode != MODE_VIEW">Create</button>
                            </div>
                          </div>                              
                          <div class="box-body no-padding table-responsive">
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th style="width:10px;text-align:right">#</th>
                                  <th style="text-align:center;">Action</th>
                                  <th style="text-align:left;">Name</th>
                                  <th style="text-align:left;">URL</th>
                                  <th style="text-align:left;">Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(row, i) in listMenu" v-bind:key="i">
                                  <td class="text-nowrap" style="text-align:right;">{{ startSeqListMenu + i + 1}}</td>
                                  <td class="text-nowrap" style="text-align:center;">
                                    <a href="#" v-on:click="onDisplayRoleMenu(row)" ref="displayRowMembership" style="padding-right:5px">
                                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                    </a>
                                    <a href="#" v-on:click="onEditRoleMenu(row)" ref="editRowMembership" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                                      <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                    </a>
                                    <a href="#" v-on:click="onDeleteRoleMenu(row)" ref="deleteRowMembership" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                                      <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                    </a>                                                                               
                                  </td>
                                  <td class="text-nowrap" style="text-align:left;">{{ row.menuName }}</td> 
                                  <td class="text-nowrap" style="text-align:left;">{{ row.menuUrl }}</td>
                                  <td class="text-nowrap" style="text-align:left;">{{ row.menuDescription }}</td>                                  
                                  <td hidden>{{ row.id }}</td>
                                  <td hidden>{{ row.roleId }}</td>
                                  <td hidden>{{ row.menuId }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>                                           
                    <div v-bind:class="{ active: tabActive == TAB_AUTHOBJECT }" class="tab-pane" id="tab_2">
                      <div class="col-md-12">
                        <div class="box no-border">
                          <div class="box-header" style="height:40px;">          
                            <div class="box-tools">              
                              <button @click="onCreateRoleAuthObject" class="btn btn-primary" v-if="viewMode != MODE_VIEW">Create</button>
                            </div>
                          </div>                              
                          <div class="box-body no-padding table-responsive">
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th style="width:10px;text-align:right">#</th>
                                  <th style="text-align:center;">Action</th>
                                  <th style="text-align:left;">Name</th>
                                  <th style="text-align:left;">Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(row, i) in listAuthObject" v-bind:key="i">
                                  <td class="text-nowrap" style="text-align:right;">{{ startSeqListAuthObject + i + 1}}</td>
                                  <td class="text-nowrap" style="text-align:center;">
                                    <a href="#" v-on:click="onDisplayRoleAuthObject(row)" style="padding-right:5px">
                                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                    </a>
                                    <a href="#" v-on:click="onEditRoleAuthObject(row)" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                                      <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                    </a>
                                    <a href="#" v-on:click="onDeleteRoleAuthObject(row)" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                                      <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                    </a>                                                                               
                                  </td>
                                  <td class="text-nowrap" style="text-align:left;">{{ row.authObjectName }}</td> 
                                  <td class="text-nowrap" style="text-align:left;">{{ row.authObjectDescription }}</td>                                  
                                  <td hidden>{{ row.id }}</td>
                                  <td hidden>{{ row.roleId }}</td>
                                  <td hidden>{{ row.authObjectId }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div> 
                  </div>
                </div>
              </div>              
            </div>
            <!-- /.box-body -->
            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
              </div>
            </div>
            <!-- /.box-footer -->
          </form>
        </div>          
      </div>
    </div> 
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_MENU = 'tabMenu'
const TAB_AUTHOBJECT = 'tabAuthObject'

export default {
  name: 'RoleForm',
  data() {
    return {
      MODE_NONE: MODE_NONE,
      MODE_CREATE: MODE_CREATE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: ''
      },
      TAB_MENU: TAB_MENU,
      TAB_AUTHOBJECT: TAB_AUTHOBJECT,
      listMenu: null,
      listAuthObject: null,
      startSeqListMenu: 0,
      startSeqListAuthObject: 0,
      callback: undefined
    }
  },
  created() {
    if (this.$route.params) {
      this.callback = this.$route.params.callback
      this.formData.id = this.$route.params.id
      this.viewMode = this.$route.params.mode
    }

    this.tabActive = TAB_MENU
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    getDetail() {
      if (this.formData.id && this.formData.id !== 0) {
        api
          .request('Account', 'get', '/api/Role/GetDetail?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data
            this.formData = data.entity
          })
          .then(response => {
            this.onClickTabMenu(this.formData.id)
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
    },
    onCreate () {
      this.formData.id = 0
      this.formData.name = ''
      this.listMenu = null
      this.listAuthObject = null
      this.startSeqListMenu = 0
      this.startSeqListAuthObject = 0
      this.viewMode = MODE_CREATE
    },
    onEdit() {
      this.viewMode = MODE_UPDATE
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      let name = this.callback[this.callback.length - 1].name
      let id = this.callback[this.callback.length - 1].id
      let mode = this.callback[this.callback.length - 1].mode
      this.callback.splice(this.callback.length - 1, 1)
      let params = {
        id: id,
        mode: mode,
        callback: this.callback
      }
      this.$router.push({ name: name, params: params })
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Account', 'post', '/api/Role/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabMenu(roleId) {
      api
        .request('Account', 'get', '/api/Role/InquiryRoleMenuByRoleId?RoleId=' + roleId, null)
        .then(response => {
          var data = response.data
          this.listMenu = data.entity
        })
        .then(response => {
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabAuthObject(roleId) {
      api
        .request('Account', 'get', '/api/Role/InquiryRoleAuthObjectByRoleId?RoleId=' + roleId, null)
        .then(response => {
          var data = response.data
          this.listAuthObject = data.entity
        })
        .then(response => {
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateRoleMenu() {
      if (!this.formData.id || this.formData.id === 0) {
        SweetAlert.fire('System Checking', 'Please save this role', 'warning')
        return
      }

      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: 0,
        roleId: this.formData.id,
        mode: MODE_CREATE,
        callback: this.callback
      }
      this.$router.push({ name: 'Role Menu Form', params: params })
    },
    onDisplayRoleMenu(row) {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.callback
      }
      this.$router.push({ name: 'Role Menu Form', params: params })
    },
    onEditRoleMenu(row) {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: row.id,
        mode: MODE_UPDATE,
        callback: this.callback
      }
      this.$router.push({ name: 'Role Menu Form', params: params })
    },
    onDeleteRoleMenu(row) {
      SweetAlert.fire({
        title: 'Are you sure to delete this data?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.deleteRoleMenu(row)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
        }
      })
    },
    deleteRoleMenu(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        RoleId: data.roleId,
        MenuId: data.menuId
      }
      api.request('Account', 'post', '/api/Role/DeleteRoleMenu', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.onClickTabMenu(this.formData.id)
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    onCreateRoleAuthObject() {
      if (!this.formData.id || this.formData.id === 0) {
        SweetAlert.fire('System Checking', 'Please save this role', 'warning')
        return
      }

      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: 0,
        roleId: this.formData.id,
        mode: MODE_CREATE,
        callback: this.callback
      }
      this.$router.push({ name: 'Role AuthObject Form', params: params })
    },
    onDisplayRoleAuthObject(row) {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.callback
      }
      this.$router.push({ name: 'Role AuthObject Form', params: params })
    },
    onEditRoleAuthObject(row) {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: row.id,
        mode: MODE_UPDATE,
        callback: this.callback
      }
      this.$router.push({ name: 'Role AuthObject Form', params: params })
    },
    onDeleteRoleAuthObject(row) {
      SweetAlert.fire({
        title: 'Are you sure to delete this data?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.deleteRoleAuthObject(row)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
        }
      })
    },
    deleteRoleAuthObject(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        RoleId: data.roleId,
        AuthObjectId: data.authObjectId
      }
      api.request('Account', 'post', '/api/Role/DeleteRoleAuthObject', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.onClickTabAuthObject(this.formData.id)
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// RoleForm.vue?e8313854